<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog">
      <v-toolbar tabs dark>
        <v-tabs
          align-with-title
          fixed-tabs
          centered
          icons-and-text
          v-model="tabs"
          color="transparent"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab key="settings">
            Select data
            <v-icon>settings</v-icon>
          </v-tab>
          <v-tab key="preview" :disabled="true">
            Preview data
            <v-icon>find_in_page</v-icon>
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item
          key="settings"
        >
          <v-card>
            <v-card-text>
              <v-subheader>Select Years</v-subheader>
              <table
                id="download_years"
                class="v-datatable v-table theme--light v-list--dense"
              >
                <tbody>
                  <tr>
                    <td>
                      Start Year
                      <v-menu
                        origin="center center"
                        transition="scale-transition"
                        bottom
                        offset-y
                        :max-height="downloadSelectsHeight"
                        class="scroll-y overflow-y-auto"
                      >
                        <template slot="activator" slot-scope="{ on: menu }">
                          <v-tooltip
                            right
                            :disabled="selectedYear.alert === false"
                          >
                            <template slot="activator" slot-scope="{ on: tooltip }">
                            <span v-on="tooltip">
                              <v-btn v-on="menu">
                                <span>{{ selectedYearSpan.start.year }}</span>
                              </v-btn>
                            </span>
                            </template>
                            <span v-if="selectedYear.alert">
                              <v-icon dark small>warning</v-icon> {{ selectedYear.message }}
                            </span>
                          </v-tooltip>
                        </template>
                        <v-list dense>
                          <v-tooltip
                            right
                            :disabled="y.alert === false"
                            v-for="(y, yindex) in years"
                            :key="yindex"
                          >
                            <v-list-tile
                              slot="activator"
                              class="year-container"
                              @click="switchStartYear(y)"
                            >
                              <v-list-tile-title class="year">
                                {{ y.year }}
                              </v-list-tile-title>
                            </v-list-tile>
                            <span v-if="y.alert">
                              <v-icon dark small>warning</v-icon> {{ y.message }}
                            </span>
                          </v-tooltip>
                        </v-list>
                      </v-menu>
                    </td>
                    <td>
                      End Year
                      <v-menu
                        origin="center center"
                        transition="scale-transition"
                        bottom
                        offset-y
                        :max-height="downloadSelectsHeight"
                        class="scroll-y overflow-y-auto"
                      >
                        <template slot="activator" slot-scope="{ on: menu }">
                          <v-tooltip
                            right
                            :disabled="selectedYear.alert === false"
                          >
                            <template slot="activator" slot-scope="{ on: tooltip }">
                            <span v-on="tooltip">
                              <v-btn v-on="menu">
                                <span>{{ selectedYearSpan.end.year }}</span>
                              </v-btn>
                            </span>
                            </template>
                            <span v-if="selectedYear.alert">
                              <v-icon dark small>warning</v-icon> {{ selectedYear.message }}
                            </span>
                          </v-tooltip>
                        </template>
                        <v-list dense>
                          <v-tooltip
                            right
                            :disabled="y.alert === false"
                            v-for="(y, yindex) in years"
                            v-if="!disableEndYear(y.year)"
                            :key="yindex"
                          >
                            <v-list-tile
                              slot="activator"
                              class="year-container"
                              @click="switchEndYear(y)"
                            >
                              <v-list-tile-title class="year">
                                {{ y.year }}
                              </v-list-tile-title>
                            </v-list-tile>
                            <span v-if="y.alert">
                              <v-icon dark small>warning</v-icon> {{ y.message }}
                            </span>
                          </v-tooltip>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
              <v-subheader>Select Indicators</v-subheader>
              <table
                id="indicator-selection"
                class="v-datatable v-table theme--light v-list--dense"
              >
                <thead>
                  <tr>
                    <th role="columnheader" scope="col" class="column text-xs-left secondary">Indicator</th>
                    <th role="columnheader" scope="col" class="column text-xs-left secondary"
                      v-for="n in normalizations" :key="'add_to_download_'+n.id">
                      <span v-if="n.id === noNormalization.id">Add non-normalized data</span>
                      <span v-else>Add data normalized by {{ n.value.toLowerCase() }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in indicatorListBasic" :key="'download_tr'+index">
                    <td v-if="i.hasOwnProperty('text')">{{i.text}}</td>
                    <td
                      v-if="i.hasOwnProperty('text')"
                      v-for="n in normalizations"
                      :key="downloadKey(i, n)"
                    >
                      <v-checkbox
                        :input-value="indicatorsToDownload[downloadKey(i, n)]"
                        :disabled="!i.norm_by.find(d => d.id === n.id)"
                        @change="toggleDownloadItem({
                        indicator: i,
                        normalization: n,
                        downloadKey: downloadKey(i, n)
                        })"
                      >
                      </v-checkbox>
                    </td>
                    <td v-if="!i.hasOwnProperty('text')" :colspan="normalizations.length + 1" style="text-transform: capitalize;">
                      <v-subheader inset>{{i.header}}</v-subheader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-card>

        </v-tab-item>
        <v-tab-item
          key="preview">
          <v-data-table
          v-if="false"
          :headers="cData.headers"
          :items="cData.items"
          :pagination.sync="pagination"
          class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td @click="clickItem(props.item)" v-for="header in cData.headers" :key="header.value">
                {{ props.item[header.value] }}
              </td>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
      <v-card>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat="flat" @click="dialog = false">Close</v-btn>
      <v-btn
        @click="downloadData(getData(false))"
        target="_blank">Download CSV-File</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// There are lots of thinkgs in this Download Dialog which aren't flexible enough to keep up with changes,
// there are also no comments what so ever to explain the idea behind this structure.
// Additionally, there are users that having issues with downloads anyway.
// TODO: Rewrite the entire DownloadDialog
import { mapState } from 'vuex'
import { downloadCSV } from '../util'
import constants from '@/constants.js'

export default {
  props: {
    active: {type: Boolean}
  },
  data () {
    return {
      tabs: null,
      pagination: {
        'sortBy': 'column1',
        'descending': true,
        'rowsPerPage': 10
      },
      indicatorsToDownload: {},
      indicatorListBasic: [],
      // TODO: Populate it with "normalizations" from the store
      noNormalization: constants.NO_NORM,
      downloadSelectsHeight: 100
    }
  },
  computed: {
    ...mapState([
      'years',
      'selectedYear',
      'indicators',
      'data',
      'selectedIndicator',
      'normalizations'
    ]),
    dialog: {
      get () {
        return this.active
      },
      set (dialog) {
        this.$emit('update:active', dialog)
      }
    },
    selectedYearSpan: {
      get () {
        return this.$store.state.selectedYearSpan
      },
      set (yearSpan) {
        this.$store.commit('selectYearSpan', yearSpan)
      }
    },
    selectedIndicatorSet: {
      get () {
        return this.$store.state.selectedIndicatorSet
      },
      set (selectedIndicatorSet) {
        this.$store.commit('selectIndicatorSet', selectedIndicatorSet)
      }
    },
    cData () {
      if (this.data.length === 0) {
        return {headers: [], items: []}
      }

      let firstDim = this.data[0].DTO.group_by[0]
      let secondDim = this.data[0].DTO.group_by[1]
      let thirdDim = this.data[0].DTO.group_by[2]

      let headers = [
        {
          text: firstDim.charAt(0).toUpperCase() + firstDim.slice(1),
          align: 'left',
          value: firstDim,
          class: 'secondary'
        }
      ]

      if (secondDim !== undefined) {
        headers.push({
          text: secondDim.charAt(0).toUpperCase() + secondDim.slice(1),
          align: 'left',
          value: secondDim,
          class: 'secondary'
        })
      }

      if (thirdDim !== undefined) {
        headers.push({
          text: thirdDim.charAt(0).toUpperCase() + thirdDim.slice(1),
          align: 'left',
          value: thirdDim,
          class: 'secondary'
        })
      }

      headers.push({
        text: 'Indicator',
        value: 'indicator',
        class: 'secondary'
      })

      headers.push({
        text: 'Value', // this.$store.state.indicatorMap.get(this.chartData.indicator_code),
        value: 'prettyValue',
        class: 'secondary'
      })

      let that = this
      let items = []
      this.data.forEach(x => {
        let indCodeWithNorm = x.DTO.indicator_code + '-' + 'norm_' + x.normalization.id
        if (that.indicatorsToDownload[indCodeWithNorm] === true) {
          // filter out indicators which should get downloaded
          items = items.concat(x.DTO.data.filter(d => d.year <= that.selectedYearSpan.end.year && d.year >= that.selectedYearSpan.start.year).map(
            function (d) {
              let tmp = {
                value: false,
                code: d[firstDim]
              }
              let normInfo = x.normalization.id === that.noNormalization.id ? ' (not normalised)' : ' normalised by ' + x.normalization.value
              tmp[firstDim] = that.getFullName(d[firstDim])
              if (secondDim !== undefined) { tmp[secondDim] = that.getFullName(d[secondDim]) }
              if (thirdDim !== undefined) { tmp[thirdDim] = that.getFullName(d[thirdDim]) }
              tmp['exactValue'] = d.value
              // tmp['indicator'] = that.$store.state.indicatorMap.get(x.DTO.indicator_code) + normInfo
              tmp['indicator'] = that.$store.state.indicators.find(n => n.code === x.DTO.indicator_code).text + normInfo
              //   .indicators.find(n => n.code === pi.indicator_id)
              // tmp['indicator'] = x.DTO.indicator_code + normInfo
              return tmp
            }, this))
        }
      }, this)
      return {headers: headers, items: items}
    },
    createIndicatorListBasic () {
      // we don't need to pass the full indicator objects just for displaying some text on the frontend
      let indicatorsBasicInfo = this.indicators.map(i => {
        let iMinimal = {}
        if (i.header) {
          iMinimal.header = i.header
        } else {
          iMinimal = {code: i.code, text: i.text, uri: i.uri, norm_by: i.norm_by}
        }
        return iMinimal
      })
      return indicatorsBasicInfo
    },
    fillIndicatorsToDownload () {
      let indicatorCodes = this.indicatorListBasic.reduce((filtered, i) => {
        if (i.text) {
          let code = i.code
          i.norm_by.forEach(n => {
            filtered.push(code + '-norm_' + n.id)
          })
        }
        return filtered
      }, [])

      let obj = Object.assign(...indicatorCodes.map(key => ({ [key]: false })))
      return obj
    }
  },
  methods: {
    downloadData (data) {
      downloadCSV(data)
      this.dialog = !this.dialog
    },
    downloadKey (ind, norm) {
      // Why this format?
      return ind.code + '-norm_' + norm.id
    },
    toggleDownloadItem (payload) {
      let key = payload.downloadKey
      this.indicatorsToDownload[key] = !this.indicatorsToDownload[key]

      if (this.indicatorsToDownload[key]) {
        this.$store.dispatch('loadIndicatorData', payload)
      }
    },
    switchStartYear (yearObj) {
      this.selectedYearSpan.start = yearObj
      this.checkEndYear(yearObj)

      // set end year to start year on impossible time span combinations
      // (when start year is newer than end year)
      if (this.selectedYearSpan.start.year > this.selectedYearSpan.end.year) {
        this.selectedYearSpan.end = this.selectedYearSpan.start
      }
    },
    checkEndYear (yearObj) {
      let year = yearObj.year
      if (year < this.selectedYearSpan.start.year) {
        this.selectedYearSpan.end.year = this.selectedYearSpan.start.year
      }
    },
    // visually disables "unallowed" end years in dropdown (older than start years)
    disableEndYear (year) {
      return this.selectedYearSpan.start.year > year
    },
    // switch end year; only works for allowed years, otherwise end year remains same
    switchEndYear (yearObj) {
      if (this.disableEndYear(yearObj.year) === false) { // TODO not needed anymore
        this.selectedYearSpan.end = yearObj
      }
      return this.selectedYearSpan.end.year
    },
    getData (pretty = true) {
      if (!pretty) {
        let exactHeaders = this.cData.headers.filter(h => h.value !== 'prettyValue')
        exactHeaders.push({
          text: 'Value',
          value: 'exactValue',
          class: 'secondary'
        })

        return Object.assign(this.cData, {headers: exactHeaders})
      }
      return this.cData
    },
    getFullName (d) {
      return this.$store.state.geoMap.has(d) ? this.$store.state.geoMap.get(d) : this.$store.state.topicMap.has(d) ? this.$store.state.topicMap.get(d).text : d
    },
    calculateDownloadWindowSize () {
      let downloadWindowHeight = document.getElementsByClassName('v-dialog--active')[0].clientHeight
      let tabsHeight = document.getElementsByClassName('v-tabs')[0].clientHeight
      let subheader = document.getElementsByClassName('v-subheader')[0].clientHeight
      let table = document.getElementById('download_years').clientHeight // contains the selects
      this.downloadSelectsHeight = downloadWindowHeight - tabsHeight - 16 - subheader - table - 10
    }
  },
  mounted () {
    if (this.$parent._isMounted) {
      this.indicatorListBasic = this.createIndicatorListBasic
      this.indicatorsToDownload = this.fillIndicatorsToDownload
    }
    this.$nextTick(() => {
      this.calculateDownloadWindowSize()
      window.addEventListener('resize', () => {
        this.calculateDownloadWindowSize()
      })
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', window)
  }
}
</script>

<style scoped lang="css">
  /* disable hover colour for tables */
  #download_years tr:hover,
  #indicator-selection tr:hover {
    background-color: transparent;
  }

  #download_years {
    width: unset;
  }
  #download_years td {
    padding-right: unset;
  }

  .year-container > a.v-list__tile {
    justify-content: flex-end;
  }
  .year {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/DownloadDialog.vue